import paths from '../../paths';

import chartsPage from '../../pages/ProjectsPage/reducers/init';
import teamMembersPage from '../../pages/TeamMembersPage/reducers/init';
import teamInvitationsPage from '../../pages/TeamInvitationsPage/reducers/init';
import teamGroupsPage from '../../pages/TeamGroupsPage/reducers/init';
import themesPage from '../../pages/ThemesPage/reducers/init';
import settingsPage from '../../pages/SettingsPage/reducers/init';
import apiPage from '../../pages/ApiPage/reducers/init';
import teamWebhooksPage from '../../pages/TeamWebhooksPage/reducers/init';
import customiseEditorPage from '../../pages/CustomiseEditorPage/reducers/init';
import billingPage from '../../pages/BillingPage/reducers/init';
import plansPage from '../../pages/PlansPage/reducers/init';
import billingHistoryPage from '../../pages/BillingHistoryPage/reducers/init';
import ShowChartPage from '../../pages/ShowChartPage/reducers/init';
import tableEditorPage from '../../pages/TableEditorPage/reducers/init';
import layoutEditorPage from '../../pages/LayoutEditorPage/reducers/init';
import chartEditorPage from '../../pages/ChartEditorPage/reducers/init';
import projectConfig from '../../pages/Editor/reducers/init';

export default {
  profile: {
    groups: [],
    chartsCreated: 0,
  },
  app: {
    paths: paths,
    error: '',
    loading: true,
  },
  chartsPage,
  teamMembersPage,
  teamInvitationsPage,
  teamGroupsPage,
  themesPage,
  settingsPage,
  apiPage,
  teamWebhooksPage,
  customiseEditorPage,
  billingPage,
  plansPage,
  billingHistoryPage,
  ShowChartPage,
  projectConfig,
  chartEditorPage,
  tableEditorPage,
  layoutEditorPage,
};
